export const CREATEFILESFOLDERS_ACTION = 'CREATEFILESFOLDERS_ACTION'
export const WRITEFILE = 'WRITEFILE'
export const COPYFILESFOLDERS_ACTION = 'COPYFILESFOLDERS_ACTION'
export const GETFOLDERCONSTANTS = 'GETFOLDERCONSTANTS'
export const DELETEFILESFOLDERS_ACTION = 'DELETEFILESFOLDERS_ACTION'
export const READFILE = 'READFILE'
export const UNZIPFILES = 'UNZIPFILES'
export const EXPORTTOPDF = 'EXPORTTOPDF'
